class RemoveClubDialog extends ConfirmRemovalModal {
  constructor() {
    super();
    // Bind any methods you plan to override and use in this subclass.
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }
  
  connectedCallback() {
    const confirmBtn = this.querySelector('[data-action="confirm-remove"]');
    const cancelBtn = this.querySelector('[data-action="cancel-remove"]');
    
    if (confirmBtn) {
      confirmBtn.addEventListener('click', this.handleConfirm);
    } else {
      console.warn("Confirm button not found");
    }
    
    if (cancelBtn) {
      cancelBtn.addEventListener('click', this.handleCancel);
    } else {
      console.warn("Cancel button not found");
    }
  }
  
  showMemberProduct() {
    const cart = window.__abc.ShopifyCartData.cart;
    const cartMetaData = window.__abc.ShopifyCartData.cartMetaFields;
    // Search cartMetaData for items with tag "ACMemberOnly" 
    // while excluding a specific id.
    const memberOnlyItems = cartMetaData.filter((item) => {
      return item.tags && item.tags.includes('ACMemberOnly') && item.id != '31874798878801';
    });
    
    if (memberOnlyItems.length > 0) {
      // Get the first matched member-only item and find the corresponding cart item via item.key.
      const memberOnlyItem = memberOnlyItems[0];
      const itemKey = memberOnlyItem.key;
      const item = cart.items.find((item) => item.key === itemKey);
      const backgroundColor = memberOnlyItem.productMetafields.product_background_color;
      
      const itemImage = item.featured_image.url;
      const itemTitle = item.title;
      
      // Create a new element using a template string.
      const elementToAdd = document.createElement('div');
      elementToAdd.innerHTML = `
        <div class='remove_club_modal__items_image' style='background-color:${backgroundColor};'>
          <img src='${itemImage}' alt='${itemTitle}' />
        </div>
        <div class='flex flex-row items-center' style='gap:4px;'>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <rect x="0.564453" y="0.00128174" width="13.3412" height="0.799084" transform="rotate(45 0.564453 0.00128174)" fill="#E26650"/>
              <rect y="9.43365" width="13.3412" height="0.799084" transform="rotate(-45 0 9.43365)" fill="#E26650"/>
            </svg>
          </span>
          <p class='p14'>${itemTitle}</p>
        </div>
      `;
      
      const itemsContainer = this.querySelector('.remove_club_modal__items');
      if (itemsContainer.children.length === 2) {
        itemsContainer.replaceChild(elementToAdd, itemsContainer.firstElementChild);
      } else {
        itemsContainer.insertBefore(elementToAdd, itemsContainer.firstChild);
      }
    }
  }
  
  show(opener) {
    
    this.showMemberProduct();
    super.show(opener);
  }
  
  handleConfirm(event) {
    // const itemKey = event.target.getAttribute('data-item-key');
    //console.log({ itemKey });
    //document.querySelector('subscription-builder');
    
    // const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');;
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    
    const cart = window.__abc.ShopifyCartData.cart;
    const cartMetaData = window.__abc.ShopifyCartData.cartMetaFields;
    const productsToRemove = [];
    const subscriptionBundleIds = [];
    const acMembersOnlyProducts = cartMetaData.filter((cartItem) => {
      
      if (cartItem.tags.includes('ACMemberOnly')) {
        const cartItemDetails = cart.items.find((item) => item.key === cartItem.key);
        if (cartItem.selling_plan_groups.length > 0) {
          const bundleId = cartItemDetails.properties._rc_bundle;
         if (bundleId) {
          if (!subscriptionBundleIds.includes(bundleId)) {
            subscriptionBundleIds.push(bundleId);
          }
         }
        } 
        return cartItem;
      }
    });
  
    if (acMembersOnlyProducts) {
      acMembersOnlyProducts.forEach((item) => {
        productsToRemove.push(item);
      });
    }

    if (subscriptionBundleIds.length > 0) {
      subscriptionBundleIds.forEach((bundleId) => {
        const bundleItem = cart.items.filter((item) => item.properties._rc_bundle === bundleId);
        if (bundleItem.length > 0) {
          bundleItem.forEach((item) => {
            const itemKey = item.key;
            const itemExists = productsToRemove.find((product) => {
              return product.key == itemKey
            });
            if (!itemExists) {
              productsToRemove.push(item);
            }
          });
        }
        
      });
    } 
    
    const clubItem = cart.items?.find((item) => item.id == 40807499726929);
    if (clubItem) productsToRemove.push(clubItem);
    //console.log({productsToRemove}) 
     cartItems.removeBulk(productsToRemove);
    this.hide();
    
  }
  
  handleCancel() {
    this.hide();
  }
  
  removeItemFromCart(itemKey) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0,
      }),
    })
    .then((response) => response.json())
    .then((cart) => {
      this.hide();
      location.reload();
    })
    .catch((error) => {
      console.error('Error removing item from cart:', error);
      this.hide();
    });
  }
}

// Register the custom element using a new tag name.
customElements.define('remove-club-dialog', RemoveClubDialog);
